<template>
  <v-app id="app" :class="computedClasses">
    <v-main class="primary darken-1 min-height-100sv max-height-100sv overflow-hidden" :class="computedClasses">
      <v-overlay color="primary darken-1" opacity="1" class="p-absolute" v-if="!$hub.isReady() && !showNavigation">
        <v-container fluid pa-0 d-flex flex-column align-center safe-area-padding-top safe-area-padding-bottom>
          <img src="/assets/hub-logo-vert-notext.png" width="120" class="grow-0" draggable="false" />
          <!-- <v-progress-circular indeterminate color="white" :size="28" class="mb-n7" /> -->
        </v-container>
      </v-overlay>
      <router-view @check-legal="checkLegal" :platform="platform" :desktop="desktop" :fullscreen="fullscreen" :keyboard-size="keyboardSize" />
      <hub-error-overlay ref="errorOverlay" :platform="platform" :fullscreen="fullscreen" :keyboard-size="keyboardSize" />
      <v-snackbar
        v-model="notification.display"
        :vertical="true"
        :timeout="notification.timeout"
        rounded="lg"
        elevation="10"
        top
        transition="dialog-top-transition"
        class="notification-snack px-4 safe-area-padding-top-dialog"
        v-touch="{
          up: () => hideNotification(),
        }"
      >
        <v-container @click="actionNotification" fluid d-flex align-center pa-3 full-width full-height>
          <hub-list-avatar v-if="notification.group" class="ma-0 mr-3" :image-id="notification.group.imageId" :image-from="group._id" type="group" :color="notification.group.color"></hub-list-avatar>
          <div class="">
            <p class="text-body-2 font-weight-bold ma-0" v-html="notification.title"></p>
            <p class="text-body-2 ma-0 two-lines" v-html="notification.body"></p>
          </div>
        </v-container>
      </v-snackbar>
    </v-main>

    <dialog-legal
      ref="legalDialog"
      acknowledge
      @accept="acceptLegal"
      @decline="declineLegal"
    />
    <dialog-alert
      ref="updateDialog"
      @confirm="confirmUpdate"
      @cancel="cancelUpdate"
      title="App Update"
      action-label="Update"
    />
    <dialog-notification-question-response
      ref="questionResponseDialog"
    />
  </v-app>
</template>

<script>
import UserMixin from "@/mixins/UserMixin";

import AppService from '@/modules/hub-module/services/app'
import Legal from '@/modules/hub-module/services/legal'

// import HubAppMenu from "@/components/HubAppMenu";
import HubErrorOverlay from "@/components/HubErrorOverlay";
import HubListAvatar from "@/components/HubListAvatar";

import DialogLegal from "@/components/dialogs/DialogLegal";
import DialogAlert from "@/components/dialogs/DialogAlert";

import DialogNotificationQuestionResponse from "@/components/hub-content/dialogs/DialogNotificationQuestionResponse";

// const userAgent = navigator.userAgent || navigator.vendor || window.opera;
const parentProtocol = window.parent.location.protocol || "http";
const parentHost = window.parent.location.host || "localhost";

//plugins
let App;
try {
  App = window.parent.Capacitor.Plugins.App;
} catch (e) {
  console.error("(App) Capacitor not found.");
}

let Keyboard;
try {
  Keyboard = window.parent.Capacitor.Plugins.Keyboard;
} catch (e) {
  console.error("(Keyboard) Capacitor not found.");
}

export default {
  mixins: [UserMixin],
  components: {
    // HubAppMenu,
    // HubAppNavBar,
    HubListAvatar,
    HubErrorOverlay,
    DialogLegal,
    DialogAlert,
    DialogNotificationQuestionResponse,
  },
  data: () => ({
    updateChecked: 0,
    hasUpdate: false,
    legalDialogActive: false,
    platform: 'web',
    fullscreen: false,
    keyboardSize: 0,
    notification: {display: false, timeout: 5000, title: `Test Notification`, body: `Here is some test notification text.`},
  }),
  computed: {
    showNavigation() {
      // console.log("this.$route.path",this.$route.path)
      if (this.$route.path && this.$route.path !== "/" && this.$route.path.indexOf("/auth") < 0 && this.$route.path.indexOf("/welcome") < 0) return true;
      return false;
    },
    headerDisabled() {
      return this.$route.meta?.disableHeader;
    },
    menuDisabled() {
      return this.$route.meta?.disableMenu;
    },
    userDetails() {
      return this.user || {};
    },
    isConnected() {
      return this.$connection.isConnected();
    },
    computedClasses() {
      return ["electron", "web", "macintosh", "windows"].includes(this.platform || "") ? "desktop" : ""
			// if(this.platform === 'macintosh' && !this.fullscreen) return 'window-titlebar macintosh'
			// else if(this.platform === 'windows') return 'window-titlebar windows'
			// return this.platform
		},
    desktop() {
      if(["electron", "macintosh", "windows"].includes(this.platform || "")) return true;
      return (window.innerWidth >= 768 && window.innerHeight >= 1024) || (window.innerWidth >= 1024 && window.innerHeight >= 768);
    }
  },
  watch: {
    isConnected(val) {
      // console.log("isConnected", val);
      if(val && this.$refs.errorOverlay.status == "OFFLINE") this.checkUpdates();
      else this.handleCheckResponse({status: "OFFLINE"});
    }
  },
  methods: {
    async checkLegal() {
      await this.$hub.initialised();
      if(!this.user) return false;
      await Legal.clear();
      const legalDocs = await Legal.checkAll().then(({data}) => data);
      const needsAcknowledge = Object.values(legalDocs).find(doc => !!doc);
      if(needsAcknowledge) {
        this.legalDialogActive = true;
        this.$refs.legalDialog.open();
      }
      return needsAcknowledge;
    },
    acceptLegal() {
      this.legalDialogActive = false;
      this.$refs.legalDialog.close();
      if(this.hasUpdate) this.showUpdateDialog();
    },
    declineLegal() {
      this.legalDialogActive = false;
      this.$hub.logout();
      if(this.hasUpdate) this.showUpdateDialog();
    },
    handleCheckResponse(response) {
      const { status, estimated } = response;
      const platform = window.parent.APP_PLATFORM || "web";

      switch (status) {
        case "OK":
          this.$refs.errorOverlay.hide();
          break;
        case "UPDATE":
          if(platform === "web") return;
          
          this.$refs.errorOverlay.show({ status, title: "Please Update the App", message: "This version of the app is no longer supported. To continue using The Hub update to the latest version.", showContactUs: true, button: { label: "Update Now", action: () => {
            switch (platform) {
              case "android":
                window.open(`https://play.google.com/store/apps/details?id=app.thehub.app`, "_blank")
                break;

              case "ios":
                window.open(`https://apps.apple.com/app/the-hub-create-share-connect/id1616754012`, "_blank");
                break;

              case "macintosh":
                window.open(`https://the-hub.app/download`, "_blank");
                break;

              case "windows":
                window.open(`https://the-hub.app/download`, "_blank");
                break;
            
              default:
                window.open(`about:blank`, "_blank");
                break;
            }
          } } });
          break;

        case "MAINTENANCE":
          this.$refs.errorOverlay.show({ status, title: "App Maintenance", message: `The Hub app is currently undergoing maintenance. We expect this to be complete by ${new Date(estimated).toLocaleDateString()}. Thanks for your patience.`, showContactUs: true })
          break;

        case "OFFLINE":
          this.$refs.errorOverlay.show({ status, title: "No Internet", message: `The Hub app cannot connect to the internet. Please check your connection and try again.` })
          break;
      
        default:
          this.$refs.errorOverlay.show({ status: "ERROR", title: "Something Went Wrong", message: "Please try again later.", showContactUs: true })
          break;
      }
    },
    async checkUpdates() {
      const currentTime = new Date().getTime();
      const timeDiff = currentTime - this.updateChecked;

      // const allowedRoutes = ["assessments"];

      // if (allowedRoutes.includes(this.$route.name)) {
      //   await this.$epModule.sync();
      // }
      
      try {
        const platform = window.parent.APP_PLATFORM || `web`;
        let version = "0.0.0";

        try {
          if(window.parent?.CapacitorCustomPlatform?.getInfo) {
            version = (await window.parent.CapacitorCustomPlatform.getInfo()).version;
          } else if(window.parent?.Capacitor?.Plugins?.App?.getInfo) {
            version = (await window.parent.Capacitor.Plugins.App.getInfo()).version;
          } else {
            throw "no get info function";
          }
        } catch (err) {
          console.log(err);
          version = "0.0.0";
        }

        // console.log("version",version, platform);
        const appCheck = await AppService.check({ platform, version }).then(({data}) => data);
        this.handleCheckResponse(appCheck)

        if (appCheck.status == "OK" && timeDiff > 86400000) {
          window.parent.postMessage(
            "CHECK_UPDATE",
            `${parentProtocol}//${parentHost}`
          );
        }
      } catch (error) {
        console.log("version error",error);
        this.handleCheckResponse({status: !error.response?.status ? "OFFLINE" : "ERROR"})
      }
    },
    confirmUpdate() {
      this.updateChecked = new Date().getTime();
      this.$refs.updateDialog.close();

      window.parent.postMessage(
        "UPDATE_FULL",
        `${parentProtocol}//${parentHost}`
      );
    },
    cancelUpdate() {
      this.updateChecked = new Date().getTime();
      this.checkLegal();
    },
    setFullscreen() {
      setTimeout(() => {
        this.fullscreen = window.parent.APP_FULLSCREEN || false;
      }, 100);
    },
    async getOnlineManifest() {
			let manifest
      const { APP_API, APP_ID, APP_CHANNEL } = window.parent || {};
			try {
				manifest = await fetch(`${APP_API}/app/${APP_ID}/${APP_CHANNEL}/manifest`).then(response => response.json()).then((data) => data)
				// console.log('Online Manifest', manifest);
			} catch(e) {
				console.error('Unable to read online', e);
			}
			return manifest
		},
    showUpdateDialog() {
      this.hasUpdate = false;

      this.getOnlineManifest().then(({description}) => {
        this.$refs.updateDialog.open(
          null,
          `<p>There is a small app update.<br>Would you like to apply this now?</p>${description}`
        );
      });
    },
    hideNotification() {
      this.notification.display = false;
    },
    actionNotification() {
      if(this.notification.display && this.notification.actionData?.action) {
        const { actionData, notificationId } = this.notification;
        if(actionData?.type === "chat") {
          this.$chat.clickFunction({
            data: {
              action: actionData,
            }
          });
        } else {
          this.$notification.clickFunction({
            data: {
              action: actionData,
              notificationId
            }
          });
        }
      }
      if(this.notification.display) this.notification.display = false;
    }
  },
  created() {
    //remove join code if required
    delete window.sessionStorage.joinGroupCode;

    //manually check updates on app create/startup
    this.checkUpdates();

    this.$notification.eventbus.$on('show-question-response', (actionData) => {
      // console.log("show-question-response", actionData);
      this.$refs.questionResponseDialog.open(actionData);
    });

    if (App) {
      let self = this;

      this.platform = window.parent.APP_PLATFORM || "web";

      //Window fullscreen checker
      window.onresize = () => this.setFullscreen();

      setTimeout(function () {
        window.parent.postMessage("READY", `${parentProtocol}//${parentHost}`);
      }, 1500);

      window.addEventListener("message", (event) => {
        if (event.data === "UPDATED_MANIFEST") {
          console.log("UPDATED_MANIFEST_ENGINE");
        } else if (event.data === "UPDATED_FULL") {
          console.log("UPDATED_FULL_ENGINE");
        } else if (event.data === "ENGINE_HAS_UPDATE") {
          console.log("ENGINE_HAS_UPDATE");
          this.hasUpdate = true;
          if(this.legalDialogActive) this.checkLegal();
          else this.showUpdateDialog();
        } else if (event.data === "ENGINE_NO_UPDATE") {
          console.log("ENGINE_NO_UPDATE");
          this.checkLegal();
        } else if(event.data.includes("APP_URL_OPEN:")) {
          console.log("APP_URL_OPEN - INTERNAL");
          const url = event.data.split("APP_URL_OPEN:")[1];
          // console.log("APP_URL_OPEN - INTERNAL - URL",url);
          appUrlFunction({url});
        } else if(event.data.includes("NOTIFICATION_TOKEN")) {
          let message = JSON.parse(event.data);
          console.log("NOTIFICATION_TOKEN - INTERNAL", message.data.value);
          this.$notification.finaliseRegisterDevice({token: message.data.value, platform: this.platform});
        } else if(event.data.includes("NOTIFICATION_ACTIONED")) {
          let message = JSON.parse(event.data);
          if(message?.data?.notification?.data?.action && typeof message.data.notification.data.action === "string") {
            try {
              message.data.notification.data.action = JSON.parse(message.data.notification.data.action);
            } catch (error) {
              console.log(error);
              message.data.notification.data.action = {};
            }
          }
          console.log("NOTIFICATION_ACTIONED - INTERNAL", message);
          // alert(JSON.stringify(message));
          if(message?.data?.notification?.data?.action?.type === "chat") this.$chat.clickFunction(message?.data?.notification);
          else this.$notification.clickFunction(message?.data?.notification);
        } else if(event.data.includes("NOTIFICATION_RECEIVED")) {
          console.log("NOTIFICATION_RECEIVED");
          let message = JSON.parse(event.data);
          // alert(JSON.stringify(message.data));
          displayNotification(message.data);
        }
      });

      //first remove all app listeners
      if (window.parent.appListeners) {
        window.parent.appListeners.forEach((listener) => {
          if(listener.remove) {
            // console.log("REMOVE LISTENER");
            listener.remove();
          }
        });
        window.parent.appListeners = [];
      } else {
        App.removeAllListeners();
      }

      window.parent.appListeners = window.parent.appListeners || [];

      const stateFunction = (state) => {
        // state.isActive contains the active state
        // console.log("Internal App state changed.", state.isActive);
        if (state.isActive) {
          this.checkUpdates();

          //refresh notifications
          this.$notification.eventbus.$emit('refresh');

          //get notification stats
          this.$notification.getStats();

          //refresh chat
          this.$chat.eventbus.$emit('refresh');

          //get chat stats
          this.$chat.getStats();

          //clear chat notifications
          this.$chat.clearNotifications();
        }
      };

      //manually check updates on app create/startup
      this.checkUpdates();

      if (window.parent.CapacitorCustomPlatform) {
        // console.log("set")
        const focusListener = {
          fn: function () {
            stateFunction({ isActive: true });
          },
          remove: function () {
            window.parent.CapacitorCustomPlatform.removeListener("window:focus", this.fn);
          },
        };
        window.parent.CapacitorCustomPlatform.addListener("window:focus", focusListener.fn);
        window.parent.appListeners.push(focusListener);

        const blurListener = {
          fn: function () {
            stateFunction({ isActive: false });
          },
          remove: function () {
            window.parent.CapacitorCustomPlatform.removeListener("window:blur", this.fn);
          },
        };
        window.parent.CapacitorCustomPlatform.addListener("window:blur", blurListener.fn);
        window.parent.appListeners.push(blurListener);

        console.log("added electron window listeners");
      } else {
        const appStateChange = App.addListener("appStateChange", stateFunction);
        window.parent.appListeners.push(appStateChange);

        const appBackBtn = App.addListener("backButton", () => { window.history.back(); });
        window.parent.appListeners.push(appBackBtn);
      }

      // Listen for serious plugin errors
      // const pluginError = App.addListener("pluginError", (info) => {
      //   console.error("There was a serious error with a plugin INTERNAL", info);
      // });
      // window.parent.appListeners.push(pluginError);

      // async onBackButton() {
      // if (this.$route.name !== 'locked' && await Application.isLocked()) {
      // this.$router.push({ name: 'locked' });
      // } else if (this.$route.name !== 'locked' &&
      // this.$route.name !== 'set-pin') {
      // this.$router.go(-1);
      // }
      // }

      if(Keyboard) {
        const keyboardShow = Keyboard.addListener('keyboardDidShow', info => {
          // console.log('keyboard did show with height:', info.keyboardHeight);
          self.keyboardSize = info.keyboardHeight;
          setTimeout(() => {document.activeElement.scrollIntoView(false);}, 100);
        });

        const keyboardHide = Keyboard.addListener('keyboardDidHide', () => {
          // console.log('keyboard did hide');
          self.keyboardSize = 0;
        });

        window.parent.appListeners.push(keyboardShow);
        window.parent.appListeners.push(keyboardHide);
      }

      // if(!window.parent.CapacitorCustomPlatform) {
      //   const backButton = App.addListener("backButton", (eventData) => {
      //     console.log('App back with URL: ' +  eventData.url);
      //     App.exitApp();
      //   });
      //   window.parent.appListeners.push(backButton);
      // }

      const displayNotification = ({ title, body, data: notificationData = {} } = {}) => {
        try {
          let { notificationId, action: actionData = {}, timeout = 5000 } = notificationData;

          if(typeof actionData === "string") {
            try {
              actionData = JSON.parse(actionData);
            } catch (error) {
              console.log(error);
            }
          }

          if(actionData.chatId) {
            const notCurrentUser = (actionData.idUser || "") !== this.userDetails._id;

            const groupId = (actionData.groupId || "");
            const isGroupRoute = (this.$router?.currentRoute?.name || "").includes("main.group") && (this.$router?.currentRoute?.name || "").includes(".details") && this.$router?.currentRoute?.query?.tab === "chat";
            const isChatRoute = (this.$router?.currentRoute?.name || "").includes("main.chat.details");

            const isCurrentChat = groupId === this.$router?.currentRoute?.params?.groupId && (isGroupRoute || isChatRoute);

            if(!notCurrentUser || isCurrentChat) return;
          }

          this.$set(this, `notification`, {
            display: true,
            timeout,
            title: title || notificationData.title,
            body: body || notificationData.message,
            group: actionData.idGroup ? this.$group.get(actionData.idGroup) || null : null,
            actionData,
            notificationId
          })
        } catch (error) {
          alert(JSON.stringify(error));
        }
      };

      const appUrlFunction = (eventData) => {
        console.log("App opened with URL: " + eventData.url);

        var url = new URL(eventData.url.split("thehubapp:").join("http:"));

        if (url.pathname === "/signup") {
          this.$router.push({
            name: "auth.signup",
          });
        } if (
          (url.pathname === "/confirm" || url.pathname === "/signup/confirm") &&
          url.searchParams.get("code") &&
          url.searchParams.get("username")
        ) {
          this.$router.push({
            name: "auth.signup.confirm",
            query: {
              code: url.searchParams.get("code"),
              username: url.searchParams.get("username")
            },
          });
        } else if (
          url.pathname === "/reset" &&
          url.searchParams.get("code") &&
          url.searchParams.get("username")
        ) {
          this.$router.push({
            name: "auth.reset",
            query: {
              code: url.searchParams.get("code"),
              username: url.searchParams.get("username")
            },
          });
        } else if (
          url.pathname === "/join" &&
          url.searchParams.get("code")
        ) {
          this.$router.push({
            name: "auth.join",
            query: { code: url.searchParams.get("code") },
          });
        } else if (
          url.pathname === "/redeem" &&
          url.searchParams.get("code")
        ) {
          this.$router.push({
            name: "feed.redeem",
            query: { code: url.searchParams.get("code") },
          });
        }
      };
    }
  },
};
</script>

<style lang="scss">
@import "./styles/overrides.scss";

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

.pulse {
  animation: pulse 1s ease-in-out infinite;
}

.notification-snack {
  .v-snack__wrapper {
    width: 100%;
    max-width: 420px;
    margin: 0;
    background-color: var(--v-primary-lighten1);
    height: auto;
    
    .v-snack__content {
      width: 100%;
      min-height: 90px;
      height: 1px;
      padding: 0;

      .two-lines {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    .v-snack__action {
      display: none;
    }
  }
}
</style>